import Vue from 'vue'

export const state = {
  loading: false,
  innerLoading: false,
  messages: {
    0: 'Você não está conectado à internet. Verifique e tente novamente',
    401: 'Você não tem permissão para acessar este recurso',
    422: 'Existem informações incompletas ou inválidas',
    500: 'Sistema temporariamente indisponível. Por favor, tente novamente mais tarde'
  },
  mensagemErroDiv: ''
}

export const getters = {
  loading: state => state.loading,
  innerLoading: state => state.innerLoading,
  mensagemErroDiv: state => state.mensagemErroDiv
}

export const mutations = {
  setLoading (state, payload) {
    state.loading = payload
  },

  setInnerLoading (state, payload) {
    state.innerLoading = payload
  },

  setMensagemErroDiv (state, payload) {
    try {
      if (payload.response.data.mensagem) {
        state.mensagemErroDiv = payload.response.data.mensagem
      } else {
        state.mensagemErroDiv = ''
      }
    } catch (error) {
      state.mensagemErroDiv = ''
    }
  },

  showSuccessMsg (state, payload) {
    Vue.prototype.$toasted.show(payload.body, {
      type: 'success',
      icon: {
        name: 'fa-check-circle'
      },
      action: {
        text: 'FECHAR',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        }
      }
    })
  },

  showPaymentErrorMsg (state, message) {
    Vue.toasted.show(message, {
      icon: { name: 'fa-exclamation-triangle' },
      type: 'error',
      theme: 'bubble',
      action: {
        text: 'FECHAR',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        }
      }
    })
  },

  showErrorMsg (state, payload) {
    let message = ''
    // const status = !window.navigator.onLine ? 0 : (payload.response ? payload.response.status : 500)
    const status = payload.response ? payload.response.status : 500

    if (status === 400) {
      message = payload.response.data.message
    } else if (status === 401) {
      message = payload.response.data && payload.response.data.message ? payload.response.data.message : state.messages[status]
    } else if (status === 404) {
      message = payload.response.data && payload.response.data.message ? payload.response.data.message : 'Informações não encontradas com os paramentros informados'
    } else {
      message = state.messages[status]
    }

    Vue.toasted.show(message, {
      icon: { name: 'fa-exclamation-triangle' },
      type: 'error',
      theme: 'bubble',
      action: {
        text: 'FECHAR',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        }
      }
    })
  },

  showValidationMsg (state) {
    Vue.prototype.$toasted.show(state.messages[422], { type: 'info', icon: { name: 'fa-info-circle' } })
  }

}

export const actions = {
  setLoading ({ commit }, payload) {
    commit('setLoading', payload)
  },

  setInnerLoading ({ commit }, payload) {
    commit('setInnerLoading', payload)
  },

  setMensagemErroDiv ({ commit }, payload) {
    commit('setMensagemErroDiv', payload)
  },

  showSuccessMsg ({ commit, dispatch }, payload) {
    dispatch('setLoading', false)
    dispatch('setInnerLoading', false)
    commit('showSuccessMsg', payload)
  },

  showErrorMsg ({ commit, dispatch }, payload) {
    dispatch('setLoading', false)
    dispatch('setInnerLoading', false)
    commit('showErrorMsg', payload)
  },

  showValidationMsg ({ commit }) {
    commit('showValidationMsg')
  },

  showPaymentErrorMsg ({ commit }, message) {
    commit('showPaymentErrorMsg', message)
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/index.js